import { Grid, IconButton, Checkbox, FormControlLabel, Card, Typography } from "@material-ui/core";
import AccordionCore from "components/Shared/Accordion/AccordionCore";
import DeleteIcon from '@material-ui/icons/Delete';
import { useEffect } from "react";

const { default: UsersPageStyle } = require("../UsersPageStyle");

const useStyles = UsersPageStyle;
const ClientAccounts = ({ client, onChangeAccount, onRemoveClient, selectedClientAccount, setSelectedClientAccount }) => {
    const classes = useStyles();
    const defaultAccount = client?.clientAccounts?.find(x => x.isDefault);
    useEffect(() => {
        let selectedAccounts = [...selectedClientAccount];
        setSelectedClientAccount(selectedAccounts);
    }, [client])

    const onChangeAccountBridge = async (account, selected) => {

        if (onChangeAccount) {
            onChangeAccount();
        }

        let selectedAccounts = [...selectedClientAccount];
        if (selected) {
            if (account.isDefault) {
                selectedAccounts = selectedAccounts?.filter(x => x.clientId !== account.clientId);
                selectedAccounts.push(...client?.clientAccounts);
                setSelectedClientAccount(selectedAccounts);
                return;
            }

            if (!selectedAccounts.some(a => a.id === account.id)) {
                selectedAccounts.push(account);
            }

            setSelectedClientAccount(selectedAccounts);
        }
        else {
            let selectedAccounts = [...selectedClientAccount];
            if (account.isDefault) {
                const updatedSelectedAccounts = selectedAccounts.filter(
                    (x) => !client?.clientAccounts.some((acc) => acc === x)
                );

                setSelectedClientAccount(updatedSelectedAccounts);

                return;
            }

            if (!account.isDefault) {
                selectedAccounts = selectedAccounts.filter(x => x !== defaultAccount);
            }

            selectedAccounts = selectedAccounts.filter(x => x !== account);
            setSelectedClientAccount(selectedAccounts);
        }


    }
    const renderclientActions = (client) => {
        return <IconButton edge="end" aria-label="delete" onClick={() => onRemoveClient(client?.id)}>
            <DeleteIcon />
        </IconButton>
    }

    const getCounterByActive = (client) => {
        let activeCounts = client?.clientAccounts?.filter(acc => selectedClientAccount?.includes(acc) && !acc.isDefault);
        return `${client?.name} (${activeCounts?.length ?? "0"} of ${client?.clientAccounts?.length - 1} accounts)`
    }

    return (
        <Grid direction="row" xs={12}>
            <Grid item xs={12} >

                {
                    client?.clientAccounts?.length === 1 ?
                    <Card className={classes.list}>
                        <Grid item className={classes.restrictions} alignItems='center'>
                            {client?.name}
                            <IconButton edge="end" aria-label="delete"
                                onClick={() => onRemoveClient(client?.id)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    </Card>
                    :
                    <Grid className={classes.accountsContainer}>
                        <AccordionCore
                            classAccordionContent={classes.accordionContentStyle}
                            headerActions={renderclientActions(client)}
                            header={getCounterByActive(client)}>
                            <Grid container direction="row" spacing={2} xs={12} sx={{ Margin: "5px" }}>
                                {
                                  [...(client?.clientAccounts || [])]
                                    ?.sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0)) // default accounts first
                                    ?.map((account) => (
                                    <Grid item xs={4} key={account?.id}>
                                        <Grid direction="row" justifyContent="center" alignItems="center" xs={12}>
                                            <Grid item xs={12} className={classes.accountsSection}>
                                                <Grid item xs={8}>
                                                    <FormControlLabel
                                                        control={<Checkbox />}
                                                        label={account?.isDefault ? "All Accounts" : account?.name}
                                                        checked={selectedClientAccount?.includes(account)}
                                                        onChange={(e, checked) => onChangeAccountBridge(account, checked)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                ))}
                                <Grid container justifyContent="flex-end" sx={{ marginTop: "10px" }}>
                                    <Typography variant="caption" align="right">
                                        Note: If none of the accounts are selected, the client won't be saved.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </AccordionCore>
                    </Grid>
                }
            </Grid>
        </Grid>);
}
export default ClientAccounts;